module.exports = __webpack_public_path__ + "media/images/content-bg-e60aa75d5b5860043b613782e920ad07.jpg";